/*
 * Primary navigation, used by the sidebar, the mobile drawer and the command palette. Labels come from
 * `shell:nav.<id>`. Add an item here when a new top-level area appears (rare).
 */
import {
  CreditCard,
  GearSix,
  HardDrives,
  Lifebuoy,
  RocketLaunch,
  Sparkle,
  SquaresFour,
  UsersThree,
  type Icon,
} from '@phosphor-icons/react'

export type NavId =
  'overview' | 'servers' | 'billing' | 'ai-credits' | 'team' | 'support' | 'releases' | 'settings'

export type NavItem = { id: NavId; to: string; icon: Icon; group: 'main' | 'account'; keywords?: string[] }

export const NAV: readonly NavItem[] = [
  { id: 'overview', to: '/overview', icon: SquaresFour, group: 'main', keywords: ['home', 'dashboard'] },
  {
    id: 'servers',
    to: '/servers',
    icon: HardDrives,
    group: 'main',
    keywords: ['license', 'install', 'activation'],
  },
  {
    id: 'billing',
    to: '/billing',
    icon: CreditCard,
    group: 'main',
    keywords: ['invoice', 'payment', 'plan'],
  },
  { id: 'ai-credits', to: '/ai-credits', icon: Sparkle, group: 'main', keywords: ['ai', 'credits'] },
  { id: 'team', to: '/team', icon: UsersThree, group: 'account', keywords: ['members', 'invite'] },
  { id: 'support', to: '/support', icon: Lifebuoy, group: 'account', keywords: ['ticket', 'help'] },
  {
    id: 'releases',
    to: '/releases',
    icon: RocketLaunch,
    group: 'account',
    keywords: ['changelog', 'version', 'update'],
  },
  {
    id: 'settings',
    to: '/settings',
    icon: GearSix,
    group: 'account',
    keywords: ['profile', 'security', '2fa'],
  },
]
